import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Privacy from '../views/Privacy.vue'
import Legal from '../views/Legal.vue'
import Credits from '../views/Credits.vue'
import FullPageScroll from '../views/FullPageScroll.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Meditate',
    component: FullPageScroll
  },
  {
    path: '/legal',
    name: 'Legal',
    component: Legal
  },
  {
    path: '/credits',
    name: 'Credits',
    component: Credits
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
